import './brands.scss';


const Brands=()=>{

return (
    <div className="brands">

    <div className="title">Featured Brands</div>


    <div className="brandsGrid">

        <div className="brandIcon apple"></div>
        <div className="brandIcon iper"></div>
        <div className="brandIcon bizzy"></div>
        <div className="brandIcon lenovo"></div>
        <div className="brandIcon roche"></div>

    </div>

    </div>
)
}

export default Brands;